/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderDirectoryContactType } from './ProviderDirectoryContactType';
import {
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeFromJSONTyped,
    ProviderDirectoryContactTypeToJSON,
    ProviderDirectoryContactTypeToJSONTyped,
} from './ProviderDirectoryContactType';

/**
 * 
 * @export
 * @interface CreateDirectoryContactRequest
 */
export interface CreateDirectoryContactRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    position?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    contact_type: ProviderDirectoryContactType;
    /**
     * 
     */
    user_id?: string | null;
}



/**
 * Check if a given object implements the CreateDirectoryContactRequest interface.
 */
export function instanceOfCreateDirectoryContactRequest(value: object): value is CreateDirectoryContactRequest {
    if (!('contact_type' in value) || value['contact_type'] === undefined) return false;
    return true;
}

export function CreateDirectoryContactRequestFromJSON(json: any): CreateDirectoryContactRequest {
    return CreateDirectoryContactRequestFromJSONTyped(json, false);
}

export function CreateDirectoryContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDirectoryContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'position': json['position'] === undefined ? undefined : json['position'] === null ? null : json['position'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'contact_type': ProviderDirectoryContactTypeFromJSON(json['contact_type']),
        'user_id': json['user_id'] === undefined ? undefined : json['user_id'] === null ? null : json['user_id'],
    };
}

export function CreateDirectoryContactRequestToJSON(json: any): CreateDirectoryContactRequest {
    return CreateDirectoryContactRequestToJSONTyped(json, false);
}

export function CreateDirectoryContactRequestToJSONTyped(value?: CreateDirectoryContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'position': value['position'],
        'email': value['email'],
        'phone': value['phone'],
        'contact_type': ProviderDirectoryContactTypeToJSON(value['contact_type']),
        'user_id': value['user_id'],
    };
}

